import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import AraraIcon from '../../AraraIcon';
import Option from './OptionComponent';
import fetch from '../../../../utils/fetcher';
import { createSelectStyles, useStyles } from './styles';


const Select = ({
  id,
  setFieldValue,
  value,
  options,
  grayBackground,
  title,
  url,
  transform,
  error,
  touched,
  setFieldTouched,
  disabled,
  iconName,
  noOptionsMessage
}) => {
  const [focus, setFocus] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [optionsFromServer, setOptionsFromServer] = useState(null);
  useEffect(() => {
    if (url) {
      fetch(url).then(res => res.json()).then(data => {
        setOptionsFromServer(transform(data));
      });
    }
  }, [url, transform]);

  const selectController = React.createRef();

  const onChange = ({ value: newValue }) => {
    setFieldValue(id, newValue);
  };

  const onFocus = () => {
    setFocus(true);
    setMenuIsOpen(true);
    if (setFieldTouched) setFieldTouched(id, false);
  };

  const onBlur = () => {
    setFocus(false);
    setMenuIsOpen(false);
    if (setFieldTouched) setFieldTouched(id, true, false);
  };

  const selectOptions = optionsFromServer || options;
  const selected = selectOptions.find(opt => opt.value === value);
  const selectValue = value ? {
    label: selected ? selected.label : value,
    value,
  } : null;

  let trueIconName = iconName;
  let iconColor = 'gray';
  if (focus) {
    trueIconName = 'search';
    iconColor = 'activegray';
  } else if (touched) {
    if (value) {
      iconColor = 'green';
    } else if (error) {
      iconColor = 'red';
    }
  }

  const styles = createSelectStyles(touched, error, grayBackground);
  const classes = useStyles();
  return (
    <div className={classes.selectContainer}>
      <ReactSelect
        inputId={id}
        ref={selectController}
        components={{ Option }}
        options={selectOptions}
        onChange={onChange}
        value={selectValue}
        styles={styles}
        placeholder={title}
        isDisabled={disabled}
        onFocus={onFocus}
        onClick={onFocus}
        onBlur={onBlur}
        menuIsOpen={menuIsOpen}
        blurInputOnSelect
        noOptionsMessage={() => noOptionsMessage}
      />
      { selectValue && title && <span className={classes.title}>{title}</span> }
      <AraraIcon
        className={classes.image}
        name={trueIconName}
        variant={iconColor}
      />
      { !focus && touched && selectValue && (
        <AraraIcon
          className={classes.statusIcon}
          name="checkmark-circle"
          noVariants
        />
      )}
      { !focus && touched && !selectValue && error && (
        <AraraIcon
          className={classes.statusIcon}
          name="error-circle"
          noVariants
        />
      )}
    </div>
  );
};


Select.defaultProps = {
  value: null,
  options: [],
  url: null,
  error: false,
  transform: opt => opt,
  disabled: false,
  iconName: '',
  grayBackground: false,
  touched: false
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  grayBackground: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  url: PropTypes.string,
  transform: PropTypes.func,
  touched: PropTypes.bool,
  setFieldTouched: PropTypes.func,
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
  noOptionsMessage: PropTypes.string,
};

export default Select;
